import React from 'react';

import PropTypes from 'prop-types';

import IconButton from 'components/IconButton';
import Modal from 'components/Modal/Modal';
import RoundedButton from 'components/RoundedButton/RoundedButton';

const RetryConfirmModal = ({ isOpen, onClose, onSubmit, isSubmitting, tenant }) => (
  <Modal isOpen={isOpen} onRequestClose={onClose} showHeader={false} shouldCloseOnOverlayClick={false}>
    <div className='py-4 ps-5 pe-5'>
      <div className='border-btm d-flex justify-content-between pt-0 px-0 pb-3'>
        <h5 className='modal-title fw-bold'>Retry snapshot</h5>
        <IconButton icon='icon-cross-x' onClick={onClose} />
      </div>
      <div className='pt-4'>
        <p>
          Retry the failed snapshot for <span className='fw-bold'>{tenant}</span>? This starts a new masking job with
          the same parameters. The failed attempt is kept for reference.
        </p>
        <div className='d-flex align-items-center justify-content-end gap-2 p-3 border-t'>
          <RoundedButton text='Cancel' btnStyle='outlined' size='md' onClick={onClose} />
          <RoundedButton
            text={isSubmitting ? 'Retrying…' : 'Retry snapshot'}
            btnStyle='contained'
            color='primary'
            size='md'
            onClick={onSubmit}
            isDisabled={isSubmitting}
          />
        </div>
      </div>
    </div>
  </Modal>
);

RetryConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  tenant: PropTypes.string,
};

RetryConfirmModal.defaultProps = {
  isSubmitting: false,
  tenant: '',
};

export default RetryConfirmModal;
